import "./header.css";
import React, { useState, useEffect, useRef } from "react";
import { ArrowLeftRight, Globe } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "@mui/icons-material";
import ConfirmationDialog from "../../confirmation-dialog/confirmation-dialog";
import { useNavigate } from "react-router-dom";
import { logOut, setRole } from "../../../redux/features/userSlice";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = useSelector((state) => state.user);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleConfirmationModalOpen = () => {
    setConfirmationModalOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfirmationModalOpen(false);
  };

  const logout = () => {
    localStorage.removeItem("persist:root");
    dispatch(logOut());
    navigate("/");
  };

  const handleRoleChange = (newRole) => {
    dispatch(setRole(newRole));
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`header-wrapper ${isDropdownOpen ? "dropdown-open" : ""}`}>
      <header className="header">
        <div className="logo-container">
          <img src="/images/plus.png" alt="Logo" className="logo" />
          <div className="title">
            <div>HOSPITAL MANAGEMENT</div>
            <div>INFORMATION SYSTEM</div>
          </div>
        </div>
        <div className="user-actions">
          <div className="user-info">
            <img src="/images/admin.png" alt="Admin" className="admin-image" />
            <div className="user-text">
              <span className="admin-name">{user.role}</span>
              <span className="email">{user.email}</span>
            </div>
          </div>
          <button className="icon-button1" onClick={toggleDropdown}>
            <ArrowLeftRight size={30} />
          </button>
          {/* <button className="icon-button">
            <Globe size={25} />
          </button> */}
          <button className="icon-button" onClick={handleConfirmationModalOpen}>
            <Logout size={25} />
          </button>
          <ConfirmationDialog
            title="Are you sure you want to logout?"
            open={confirmationModalOpen}
            onCancel={handleConfirmationModalClose}
            onConfirm={logout}
            isLoading={false}
          />
        </div>
      </header>
      {isDropdownOpen && (
        <div className="dropdown-menuu" ref={dropdownRef}>
          <div className="dropdown-item" onClick={() => handleRoleChange("Admin")}>Admin</div>
          <div className="dropdown-separator" />
          <div className="dropdown-item" onClick={() => handleRoleChange("Nurse")}>Nurse</div>
          <div className="dropdown-separator" />
          <div className="dropdown-item" onClick={() => handleRoleChange("Reception")}>Reception</div>
          <div className="dropdown-separator" />
          <div className="dropdown-item" onClick={() => handleRoleChange("HR")}>HR</div>
          <div className="dropdown-separator" />
          <div className="dropdown-item" onClick={() => handleRoleChange("HOD")}>HOD</div>
          <div className="dropdown-separator" />
          <div className="dropdown-item" onClick={() => handleRoleChange("Doctors")}>Doctors</div>
        </div>
      )}
    </div>
  );
};

export default Header;
